<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'金融合作伙伴管理'},{name:'通知公告管理'}]" :title="'通知公告管理'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfoOne.putawayStatus" placeholder="请选择" size="small" clearable>
                            <el-option label="全部" :value="void 0"></el-option>
                            <el-option label="已上架" :value="1"></el-option>
                            <el-option label="已下架" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="onSearch" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                   <el-button type="primary" size="small" @click="edit()" icon="el-icon-plus">添加</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    label="公告ID">
                </el-table-column>
                <el-table-column
                    prop="title"
                    show-overflow-tooltip
                    
                    label="公告标题">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable="custom"
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    label="更新账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    sortable="custom"
                    label="更新时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="250">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="primary" class="super" plain  @click="edit(scope.row)">编辑</el-button>
                        <el-button :class="{'noclick':scope.row.isEditable==1}" size="small" :type="scope.row.putawayStatus === 0?'success':'warning'" class="super" plain
                                    @click="soldOut(scope.row)" >{{scope.row.btnValue}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
           
            
        </div>
</template>

<script>

// import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
import timeMixins from "@/mixins/timeFormat";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            ishide:false,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '1',
                label: '公告ID'
            },{
                value: '2',
                label: '公告标题'
                }, {
                value: '3',
                label: '发布账号'
            },{
                value: '4',
                label: '更新账号'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                announcementType: 1, // 类型:1=通知公告，2=协会动态，3=附加资料
                createIds: void 0, // 发布人ids
                createUserName: void 0, // 发布账号
                direction:void 0,//排序方式
                property:void 0,//排序字段
                id: void 0, //  申请ID
                startDate:void 0,
                endDate: void 0,
                modifyIds: void 0, // 更新人ids
                modifyUserName: void 0, // 更新账号
                title: void 0, // 标题
                putawayStatus: void 0 // 0=下架（未上架），1=上架
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//更新进度弹出层
            sendInfoTwo:{
                applyId:'',//id
                rate:'',//担保进度
                amount:'',//是否已放款选择值
                dealWithRemark:'',//说明
            },
            isSelect:'1',
            totalSize:null,
            statusList:[],
            scopeList:[],
            detailInfo:{
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                amount:"",
                checkExplanation:"",
                modifyUserName:"",
                updateTime:""
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.rate':{
            test:function(){
                if(this.sendInfoTwo.rate){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择担保进度'
        },
        'isSelect':{
            test:function(){
                if(this.isSelect){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择是否已放款'
        },
        'sendInfoTwo.amount':{
            test:function(){
                if(this.isSelect == 1){
                    return true
                }else{
                    if(this.sendInfoTwo.amount){
                        return true;
                    }else{
                        return false;
                    }
                }
                
            },
            message:'输入放款金额'
        },
    },
    methods:{
      //发布 编辑
        edit:function(row){
            if(row){//编辑
                this.$router.push({path:`/partnerManagement/notice/edit/${row.id}`,query:{index:'/partnerManagement/notice'},params:{id:row.id}})
            }else{//发布
                this.$router.push({path:'/partnerManagement/notice/add',query:{index:'/partnerManagement/notice'}})
            }
        },
      //表格下架,上架按钮
        soldOut:function(row){
		    let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                  const param = {
                    id:row.id,
                    putawayStatus:row.putawayStatus === 0?1:0
                  }
                    this.$axioscBody.post('/backstage/announcement/batchPutawayAnn',param).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getData();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
      onReset(){
            const param= {
              currentPage:1,//当前页
              pageSize:10,//页条数
              announcementType: 1, // 类型:1=通知公告，2=协会动态，3=附加资料
              createIds: void 0, // 发布人ids
              account: void 0, // 发布账号
              direction:void 0,//排序方式
              property:void 0,//排序字段
              id: void 0, //  申请ID
              startDate:void 0,
              endDate: void 0,
              title: void 0, // 标题
              realName: void 0 // 姓名
            }
            this.sendInfoOne = Object.assign(this.sendInfoOne,param)
            this.dateS = void 0
            this.getSelect = void 0
            this.getValue = void 0
            this.onSearch()
      },
      onSearch(){
        let lookData=this.dateS;
			if(lookData&&lookData.length>0){
				this.sendInfoOne.startDate=lookData[0];
				this.sendInfoOne.endDate=lookData[1];
			}else {
          this.sendInfoOne.startDate=null;
          this.sendInfoOne.endDate=null;
      }
			// 检索值
			let lookdell= parseInt(this.getSelect);
			this.sendInfoOne.id= void 0;
			this.sendInfoOne.createUserName= void 0;
			this.sendInfoOne.modifyUserName= void 0;
      this.sendInfoOne.title = void 0;
      // this.sendInfo.checkType = this.checkType
			if(lookdell==1){
				this.sendInfoOne.id=this.getValue;
			}else if(lookdell==2){
				this.sendInfoOne.title=this.getValue;
			}else if(lookdell==3){
        this.sendInfoOne.createUserName=this.getValue;
      }else{
				this.sendInfoOne.modifyUserName=this.getValue;
			}
      this.getData()
      },
       doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            if(row.vouchName == '经开区中小担'){
                this.ishide = true
            }else{
                this.ishide = false
            }
            // this.$axiosc.get('backstage/vouch/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.detailInfo = res.data
            //          this.dialogInfo=true;
            //     }else{
            //         this.$message({
            //             type: 'error',
            //             message: res.msg
            //         });
            //     }
            // })
            this.$router.push({path: `/partnerManagement/notice/detail/${row.id}`, query: {index: '/partnerManagement/notice',ishide:this.ishide},param:{id:row.id}})
        },
        //表格更新进度
        updateProgress:function(row){
            this.sendInfoTwo.applyId = row.id
            this.sendInfoTwo.rate = ''//担保进度
            this.sendInfoTwo.amount=''//是否已放款选择值
            this.sendInfoTwo.dealWithRemark=''//说明
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/vouch/update/progress',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.dialogAudit=false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
            this.loading = true
            this.$axiosc.get('/backstage/announcement/announcementList',{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                }else{
                    this.$alert(res.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },

    mounted(){
        const that = this
        // getDict('isShow/VOUCH_RATE').then(data=>{
        //     that.statusList = data['isShow/VOUCH_RATE']
        // })
         // 请求
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.forms .child .el-input{
  max-width:100% !important;
}
</style>